'use strict'
import _ from 'lodash'
import moment from 'moment'

function calcolaTotaliAliquote_v2(totali, valori) {
  for (let v of valori) {
    totali[`iva_${v.aliquota}`] = totali[`iva_${v.aliquota}`] || {}
    let t = totali[`iva_${v.aliquota}`]
    t.imponibile = +((t.imponibile || 0) + v.importoNettoTotale).toFixed(2)
    t.iva = +((t.iva || 0) + v.iva).toFixed(2)
    t.importo = +((t.importo || 0) + v.importoTotale).toFixed(2)
    t.aliquota = String(v.aliquota) // TODO: Verificare esenzioni ?
    t.quantita = (t.quantita || 0) + v.quantita

    totali['generale'] = totali['generale'] || {}
    let tg = totali['generale']
    tg.imponibile = +((tg.imponibile || 0) + v.importoNettoTotale).toFixed(2) 
    tg.iva = +((tg.iva || 0) + v.iva).toFixed(2)
    tg.importo = +((tg.importo || 0) + v.importoTotale).toFixed(2)
    tg.quantita = (tg.quantita || 0) + v.quantita
  }
  return totali
}

function calcolaTotaliAliquoteSpese(totaliFattura, speseFattura, scontoInFattura) {
  // Verificare se agistono sul totale imponibile o vanno ripartite per aliquota
/*   const totaleImponibile = totaliFattura.generale.imponibile
  let tg = {}
  const totali = _.omit(totaliFattura, 'generale')   
  const totaliAliquota = Object.values(totali)
  for (let t of totaliAliquota) {
    const { totaleSpese } = calcolaSpese(speseFattura, t.imponibile, totaleImponibile)
    t.imponibile += totaleSpese
    t.spese = totaleSpese
    // const calcIva = (t.aliquota !== 0) ? (t.imponibile * (parseFloat(t.aliquota) / 100)) : 0
    t.iva = +((t.aliquota !== 0) ? (t.imponibile * (parseFloat(t.aliquota) / 100)) : 0).toFixed(2)
    t.importo = +(t.imponibile + t.iva).toFixed(2)

    tg.imponibile = +((tg.imponibile || 0) + t.imponibile).toFixed(2) 
    tg.iva = +((tg.iva || 0) + t.iva).toFixed(2)
    tg.importo = +((tg.importo || 0) + t.importo).toFixed(2)
    tg.quantita = (tg.quantita || 0) + t.quantita
    tg.spese = (tg.spese || 0) + t.spese
  }
  const totaleCompleto = { ...totali, generale: tg } */
  const totaleCompleto = totaliFattura
  return totaleCompleto
}

function calcolaScadenze(totali, pagamento) {
  const scadenze = []
  var scadenza
  if (!pagamento) {
    scadenza = { data: moment().format('DD/MM/YYYY'), importo: totali.generale.importo }
    scadenze.push(scadenza)
  } else {
    if (!pagamento.giorniPagamento) {
      if (!pagamento.dataPagamento || pagamento.dataPagamento === 'DF') {
        scadenza = { data: moment().format('DD/MM/YYYY'), importo: totali.generale.importo }
      } else {
        scadenza = { data: moment().endOf('mounth').format('DD/MM/YYYY'), importo: totali.generale.importo }
      }
      scadenze.push(scadenza)
    } else {
      let numeroPagamenti = pagamento.giorniPagamento.length
      let importoScadenza = +(totali.generale.importo / numeroPagamenti).toFixed(2)
      let acc = 0
      for (let i = 0; i < numeroPagamenti; i++) {
        if (i === numeroPagamenti - 1) {
          importoScadenza = +(totali.generale.importo - acc).toFixed(2)
        }
        acc += importoScadenza
        let dataScadenza = pagamento.dataPagamento === 'DF' ? moment().add(pagamento.giorniPagamento[i], 'day') : moment().add(pagamento.giorniPagamento[i], 'day').endOf('month')
        scadenza = { data: dataScadenza.format('DD/MM/YYYY'), importo: importoScadenza }
        scadenze.push(scadenza)
      }
    }
  }
  return scadenze
}

function calcolaSpese(speseFattura, importo, totale) {
  const spese = []
  var valore
  var totaleSpese = 0
  for (let sp of speseFattura) {
    if (sp.tipo === 'IMPORTO') {
      valore = +parseFloat(sp.valore).toFixed(2)
    }
    if (sp.tipo === 'PERCENTUALE') {
      valore = +(parseFloat(sp.valore) * importo / 100).toFixed(2)
    }
    totaleSpese += +(valore * importo / totale).toFixed(2)
    spese.push({ descrizione: sp.descrizione, importo: valore })
  }
  return { spese, totaleSpese: +totaleSpese.toFixed(2) }
}

function calcolaValoriLotto(ddt, repartiStatistica) {
  const rr = ddt.righe.filter(x => x.aliquotaIva)
  let aliquote = rr.map(x => _.omit(x.aliquotaIva, 'stampante'))
  // let repartiUsati = _.uniq(rr.map(x => x.repartoFiscale))

  aliquote = _.uniqBy(aliquote, 'codice')
  const valori = []
  //for (let rp of repartiStatistica.filter(x => repartiUsati.includes(x.repartoFiscale))) { // aliquote
  for (let al of aliquote.filter(x => !_.isEmpty(x))) { // aliquote
    al.aliquota = al.valore
    const qta = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.quantita || 0) })
    const vl = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    const consegnato = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(_.get(el, 'ordine.consegnato',0)) })

    let valore = {
      quantita: qta + consegnato
    }
    valore.prezzoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    // valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(2)
    
    valore.prezzoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoTotale) })
    // valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(2)

    valore.importoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoTotale) })
    // valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(2)

    valore.importoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoTotale) })
    // valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(2)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(2)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(2)

    valore = { ...valore, ...al }
    valori.push(valore)
  }
  
  // Acquisto
  // const qta = _.sumBy(rr, (el) => { return parseFloat(el.quantita || 0) })
  const acquisto = _.sumBy(rr, (el) => {
    const acquisto = +parseFloat(_.get(el, 'appoggio.prodotto.acquisto', 0) || _.get(el, 'ordine.prezzoUnitario', 0) || _.get(el, 'valore.acquisto', 0) || _.get(el, 'valore.importoNettoUnitario', 0) || 0).toFixed(2)
    const qta = parseFloat(el.quantita || 0) + parseFloat(_.get(el, 'ordine.consegnato', 0)) 
    // return parseFloat((el.quantita || 0) * el.appoggio.prodotto.acquisto)
    return +parseFloat(qta * acquisto).toFixed(2)
  })
/*   let acquisto = {
    quantita: qta,
    valore: valoreAcquisto
  }
 */
  return { valori, acquisto }
}

function calcolaDettaglioDdt(ddt, repartiStatistica) {
  const valori = []

  for(let riga of ddt.righe) {
    let valore = {
      quantita: +parseFloat(riga.quantita).toFixed(2)
    }
    valore.prezzoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(2) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(2)
    
    valore.prezzoNettoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(2) //  _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(2)

    valore.importoUnitario = +parseFloat(riga.valore.importoUnitario).toFixed(2) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(2)

    valore.importoNettoUnitario = +parseFloat(riga.valore.importoNettoUnitario).toFixed(2) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(2)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(2)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(2)
    valore.sconto1 = riga.valore.sconto1
    valore.sconto2 = riga.valore.sconto2
    valore.sconto3 = riga.valore.sconto3
    valore.sconto4 = riga.valore.sconto4
    valore.item = { codice: riga.prodotto.codice, descrizione: riga.descrizione }

    const reparto = riga.repartoFiscale
    const rp = repartiStatistica.find(x => String(x.repartoFiscale) === reparto)

    valore = { ...valore, ...rp }
    valori.push(valore)
  }
  
  return valori
}

export default {
/*   getTotaleProdotti,
  getScontiScontrino,
  getTotaleResi, */
  // calcolaTotaliAliquote,
  calcolaTotaliAliquote_v2,
  calcolaTotaliAliquoteSpese,
  // calcolaValoriScontrino,
  // calcolaDettaglioScontrino,
  calcolaScadenze,
  calcolaSpese,
  calcolaValoriLotto
  // calcolaDettaglioDdt
}
